/* UIComponents@2.1282/lang/en.lyaml */

(function() {
  var module = {};
  var result = {};
  module.exports = {
  "en": {
    "uiAddonAvatars": {
      "defaultUploader": {
        "title": "Upload a photo",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "alerts": {
          "imageTooBig": {
            "title": "File too big",
            "text": "Please upload a smaller one"
          },
          "apiError": {
            "title": "Something went wrong",
            "text": "Please try again later"
          }
        }
      }
    },
    "ui": {
      "UIErrorMessage": {
        "error": {
          "title": "All is not lost."
        },
        "notFound": {
          "title": "All who wander are not lost."
        },
        "badRequest": {
          "title": "There was a problem loading this page."
        },
        "expired": {
          "title": "We're sorry."
        }
      },
      "UIPanelNavigator": {
        "backButton": "Go to previous screen"
      },
      "time": {
        "today": "Today at {{time}}",
        "yesterday": "Yesterday at {{time}}",
        "datetime": "{{date}} at {{time}}"
      }
    },
    "salesUI": {
      "UIAbstractDateInput": {
        "invalidDate": "Invalid date",
        "dateBelowMin": "You must choose a newer date",
        "dateAboveMax": "You must choose an older date"
      },
      "UIAvatarHoverlay": {
        "text": "Change photo"
      },
      "UIChangeArrow": {
        "decrease": "Decrease of ",
        "increase": "Increase of "
      },
      "UICopyInput": {
        "label": "Copy",
        "title": "Copy to clipboard",
        "tooltipCopied": "Copied"
      },
      "UIConfirm": {
        "defaultConfirm": "Yes",
        "defaultReject": "No"
      },
      "UICloseButton": {
        "label": "Close"
      },
      "UIDateRangePicker": {
        "placeholder": "Select a range",
        "rangeType": {
          "ALL": "All time",
          "THIS_DAY": "Today",
          "LAST_DAY": "Yesterday",
          "THIS_WEEK": "This week",
          "LAST_WEEK": "Last week",
          "THIS_MONTH": "This month",
          "LAST_MONTH": "Last month",
          "LAST_THIRTY_DAYS": "Last 30 days",
          "LAST_THREE_MONTHS": "Last 3 months",
          "THIS_QUARTER": "This quarter",
          "LAST_QUARTER": "Last quarter",
          "THIS_YEAR": "This year",
          "LAST_YEAR": "Last year",
          "CUSTOM": "Custom time period"
        }
      },
      "UIDateRangeInputs": {
        "invalidDateRange": "Please select an end date that isn't before the given start date"
      },
      "UIDropdownSelect": {
        "placeholder": "No value selected"
      },
      "UIEditableControls": {
        "cancel": "Cancel",
        "save": "Save"
      },
      "UIExpandableText": {
        "collapseButtonText": "See less",
        "expandButtonText": "See more"
      },
      "UIFileInput": {
        "defaultChangeLabel": "Change file",
        "defaultSelectLabel": "Choose file"
      },
      "UIHelpButton": {
        "clickForHelp": "Click for help"
      },
      "UIIconRating": {
        "ariaValueText": "{{value}} of {{maxValue}}"
      },
      "UILink": {
        "externalTitle": "Link opens in a new window"
      },
      "UILoading": {
        "title": "Loading…"
      },
      "UILockBadge": {
        "title": "This feature is locked"
      },
      "UIPaginator": {
        "label": "Pagination",
        "pageNumber": {
          "currentIndicator": "You are currently on ",
          "description": "Page "
        },
        "firstPage": {
          "label": "First",
          "description": "First page"
        },
        "previousPage": {
          "label": "Prev",
          "description": "Previous page"
        },
        "nextPage": {
          "label": "Next",
          "description": "Next page"
        },
        "lastPage": {
          "label": "Last",
          "description": "Last page"
        }
      },
      "UIPreviousButton": {
        "label": "Previous"
      },
      "UINextButton": {
        "label": "Next"
      },
      "UINumberRating": {
        "lowRangeLabel": "Strongly disagree",
        "highRangeLabel": "Strongly agree"
      },
      "UISearchableSelectInput": {
        "placeholder": "Search"
      },
      "UISearchInput": {
        "placeholder": "Search",
        "minimumSearchMessage": {
          "one": "Type 1 more character",
          "other": "Type {{count}} more characters"
        }
      },
      "UISelect": {
        "allOptionsSelected": "All options are selected",
        "createOption": "Create option “{{label}}”",
        "plusMore": "+ {{count}} more",
        "andMore": "…and {{count}} more.",
        "loadMore": "Load more",
        "noResults": "No results found",
        "placeholder": "Search",
        "typeToSearch": "Type to search"
      },
      "UISelectableBox": {
        "checkboxLabel": "Is Selected",
        "radioLabel": "Is Selected"
      },
      "UITableSortToggle": {
        "ascendingSort": "Ascending sort",
        "descendingSort": "Descending sort",
        "noSort": "No sort"
      },
      "UITabs": {
        "moreDropdownLabel": "More"
      },
      "UITeaseNotification": {
        "optionsButtonTooltipText": "Show options"
      },
      "UITextArea": {
        "characterCounter": {
          "one": "{{count}} character",
          "other": "{{count}} characters"
        }
      },
      "UITimePicker": {
        "placeholder": "Select a time"
      },
      "UIToggle": {
        "checkedLabel": "on",
        "uncheckedLabel": "off"
      },
      "UITypeahead": {
        "noMatchesFound": "No matches found",
        "noOptions": "None"
      },
      "UIWizard": {
        "back": "Back",
        "cancel": "Cancel",
        "done": "Done",
        "next": "Next",
        "stepCount": "Step {{stepNumber}} of {{stepCount}}"
      },
      "XSSTooltip": {
        "explanation": "This link has been disabled for your security."
      }
    }
  }
};
  result.translations = module.exports;
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-2.1282"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "cs": "static-2.1282",
    "da": "static-2.1282",
    "de": "static-2.1282",
    "en": "static-2.1282",
    "es-mx": "static-2.1282",
    "es": "static-2.1282",
    "fi": "static-2.1282",
    "fr": "static-2.1282",
    "it": "static-2.1282",
    "ja": "static-2.1282",
    "nl": "static-2.1282",
    "no": "static-2.1282",
    "pl": "static-2.1282",
    "pt-br": "static-2.1282",
    "sv": "static-2.1282",
    "zh-cn": "static-2.1282",
    "zh-hk": "static-2.1282"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-2.1282'}); }
})();


/* growthhub-ui@dev/lang/en.lyaml */

(function() {
  var module = {};
  var result = {};
  module.exports = {
  "en": {
    "app": {
      "htmlTitle": "Growth Hub"
    },
    "meta": {
      "title": "Growth Hub",
      "description": "Growth Hub is a community by HubSpot that helps millions grow better together by connecting, collaborating and contributing.  It’s a community for growth professionals (marketing, sales, customer)."
    },
    "inboundUser": {
      "welcome": {
        "newUser": {
          "header": "Welcome to your new Growth Hub profile (powered by HubSpot).",
          "description": "It has all your inbound.org profile details and hard-earned karma points. While you’re here, take a look around. You'll find tons of free tools and learning resources to organize and grow your business."
        },
        "existingUser": {
          "header": "Karma points are now here",
          "description": "Inbound.org has gone, but your hard-earned karma points haven't. You'll find them right here in your Growth Hub profile. Stay tuned for exciting changes."
        },
        "continue": "Let's go"
      },
      "stats": {
        "karmaPoints": {
          "label": "Points",
          "help": "inbound.org has gone but your hard-earned Karma Points haven't. Stay tuned for exciting changes."
        }
      }
    },
    "user": {
      "edit": {
        "firstName": "First Name",
        "lastName": "Last Name"
      }
    }
  }
};
  result.translations = module.exports;
  result.translationsLoaded = {
  "growthhub-ui": {
    "en": "static-1.742"
  }
};
  result.translationsAvailable = {
  "growthhub-ui": {
    "en": "static-1.742"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:growthhub-ui:en', {version: 'static-1.742'}); }
})();


/* growthhub-ui@dev/bundles/before.js */







//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/no-parse-loader.js!../node_modules/bender-webpack/lib/sporks/loader.js!./bundles/before.js
// module id = 568
// module chunks = 